import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import CommonTable from '../../component/common-table';
import TimeChart from './time-chart';
import moTimeTrend, { changeType } from './store/index';
import Empty from '@comp/empty/index';
import { exportExcelFile, newRate } from '@tool/index';
import moMenu from '../../store/menu';

interface IProps {}
interface IState {}

const TimeTrend = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, empty, barData, lineData, labels,
    tableTitle, tableList, overview,
  } = moTimeTrend;

  const exporttable = () => {
    const head:any = [
      ['年份', '人员规模', '变化率'],
    ];
    const list:any = [...head, ...tableList];
    const merge:any = [];
    exportExcelFile(list, merge, '时间趋势');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="effect12" className="time-trend_10 box-111">
      <SubTitle title="时间趋势" subtitle={moMenu.industryName} active={type}
        bg={Color.primaryColor(0.1)} color={Color.primary}
        tabChange={(val: string) => changeType(val)}
        contentList={['人员规模采用该行业下样本公司的员工数的50分位值。（当样本少于3个时，统计的是平均值，而不是50分位。）']} />
      {type === 'chart' ? (
        <section className="content-1015">
          {!empty ? (
            <>
              <section className="content-1030">
                <TimeChart height={400}
                  xData={labels}
                  barData={barData}
                  lineData={lineData} />
              </section>
              <section className="chart-detail_11 industry-detail_11">
                {overview.map((item: any, index: number) => (
                  <section key={index} className="item">
                    <span className="circle-111"><b /></span>
                    <p className="line-111">
                      {item.map((child: any, idx: number) => (
                        <Fragment key={idx}>
                          {child.mark === 'change_ratio' ? (
                            <>
                              {child.value >= 0 ? (
                                <span className="red-11">{newRate(child.value)}</span>
                              ) : (
                                <span className="green-11">{newRate(child.value)}</span>
                              )}
                            </>
                          ) : null}
                          {(child.mark !== 'number' && child.mark !== 'change_ratio') ? (
                            <span className="span-11">{child.value}</span>
                          ) : null}
                        </Fragment>
                      ))}
                    </p>
                  </section>
                ))}
              </section>
            </>
          ) : <Empty />}
        </section>
      ) : (
        <section className="content-151">
          {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!empty ? (
            <CommonTable titleList={tableTitle} list={tableList} />
          ) : <Empty />}
        </section>
      )}
    </section>
  );
};

export default observer(TimeTrend);
